export default __webpack_public_path__ + "media/images/manual/joanr/15-add10b0c76dca3f070926b643ad41cd3.png";